import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('enrichment/demandbase')

export const RECEIVE_END_USER_COMPANY_DATA = makeConstant('RECEIVE_END_USER_COMPANY_DATA')

export const FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS = makeConstant('FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS')

export const FETCH_ENRICHED_COMPANY_DATA = makeConstant('FETCH_ENRICHEDCOMPANY_DATA')
export const FETCH_ENRICHED_COMPANY_DATA_PENDING = makeConstant('FETCH_ENRICHED_COMPANY_DATA_PENDING')
export const FETCH_ENRICHED_COMPANY_DATA_SUCCESS = makeConstant('FETCH_ENRICHED_COMPANY_DATA_SUCCESS')
export const FETCH_ENRICHED_COMPANY_DATA_NO_RESULT = makeConstant('FETCH_ENRICHED_COMPANY_DATA_NO_RESULT')
export const FETCH_ENRICHED_COMPANY_DATA_FAILED = makeConstant('FETCH_ENRICHED_COMPANY_DATA_FAILED')
export const FETCH_ENRICHED_COMPANY_DATA_CANCELLED = makeConstant('FETCH_ENRICHED_COMPANY_DATA_CANCELLED')

export const FETCH_DECODED_CONDITION = makeConstant('FETCH_DECODED_CONDITION')
export const FETCH_DECODED_CONDITION_PENDING = makeConstant('FETCH_DECODED_CONDITION_PENDING')
export const FETCH_DECODED_CONDITION_FAILED = makeConstant('FETCH_DECODED_CONDITION_FAILED')
export const FETCH_DECODED_CONDITION_SUCCESS = makeConstant('FETCH_DECODED_CONDITION_SUCCESS')
export const FETCH_DECODED_CONDITION_CANCELLED = makeConstant('FETCH_DECODED_CONDITION_CANCELLED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/constants.js